var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Multiselect',{staticClass:"bg-white",staticStyle:{"line-height":"0.3"},attrs:{"disabled":_vm.disabled,"value":_vm.value,"options":_vm.options,"hide-selected":true,"label":"text","track-by":"value","multiple":"","preserve-search":false,"searchable":false},on:{"input":_vm.onChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }